import React from "react";
import useProductParams from "@/src/hooks/useProductParams";
import { getProductData } from "@/src/services/productService";
import { useQuery } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import LegalbirdLoader from "@/src/components/ContentLoader/LegalbirdLoader";
import UploadFineNotice from "./UploadFineNotice";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";

export default function UploadFineNoticePage() {
  const { productId } = useProductParams();
  const productApiUri = getProductData("traffic", "apiUri");
  const { data: traffic, isLoading } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId),
  });

  if (isLoading) {
    return (
      <LayoutProtectedRoutes>
        <LegalbirdLoader />
      </LayoutProtectedRoutes>
    );
  }

  return (
    <LayoutProtectedRoutes>
      <UploadFineNotice traffic={traffic} />
    </LayoutProtectedRoutes>
  );
}
